import { injectable, inject } from "inversify";
import {
  EPesquisasDrawer,
  IHttpPesquisasResponse,
  ObterPesquisaDrawerResponse,
  PesquisaDrawerGateway
} from "../ports/PesquisaDrawerGateway";
import { type HttpClient } from "@/core/services/protocols/types";
import { DITypes } from "@/core/@types/types";

@injectable()
export class PesquisaDrawerGatewayAdapter implements PesquisaDrawerGateway {
  @inject(DITypes.HORIZONS_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async obterPesquisaDrawer(): Promise<
    IHttpPesquisasResponse<ObterPesquisaDrawerResponse[]> | undefined
  > {
    const response = await this.httpClient.get<
      IHttpPesquisasResponse<ObterPesquisaDrawerResponse[]> | undefined
    >({
      url: "/financas/campanha/v1/"
    });

    return response.body;
  }

  async enviar(tipo: EPesquisasDrawer, content: unknown): Promise<boolean> {
    const model = JSON.stringify(content);
    const response = await this.httpClient.post<
      IHttpPesquisasResponse<boolean> | undefined
    >({
      url: "/financas/campanha/v1/",
      body: {
        tipo,
        content: model
      }
    });

    if (response.statusCode !== 200) {
      return false;
    }

    return true;
  }
}
